import { UserContext } from "@/context/UserContext";
import React, { useContext } from "react";
import AdminDashboard from "./AdminDashboard";
import TeacherDashboard from "../teacher/TeacherDashboard";

export default function Dashboard() {
  const userContext = useContext(UserContext);

  if (!userContext) {
    throw new Error("UserContext must be used within a UserProvider");
  }

  const { user } = userContext;

  let dashboardComponent;

  if (user?.role === "admin") {
    dashboardComponent = <AdminDashboard />;
  } else {
    dashboardComponent = <TeacherDashboard />;
  }

  return dashboardComponent;
}
